'use strict';

var y = require('yup');

function _interopNamespaceCompat(e) {
  if (e && typeof e === 'object' && 'default' in e) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n.default = e;
  return Object.freeze(n);
}

var y__namespace = /*#__PURE__*/_interopNamespaceCompat(y);

const name = 'excludesEmail';
const EXCLUDES_EMAIL_ERROR = 'excludesEmail';
y__namespace.addMethod(y__namespace.StringSchema, name, function(options) {
    return this.test({
        name,
        message: {
            key: options.error ?? EXCLUDES_EMAIL_ERROR
        },
        test: (value)=>{
            if (!value) return false;
            // [https://help.okta.com/en-us/Content/Topics/Security/policies/about-password-policies.htm#:~:text=Password%20complexity%20requirements]
            // Rejects any password that contains parts of the login ID
            // based on the delimiters (. , - _ # @).
            // For example, if the login ID is `john.smith@okta.com`,
            // a password that contain `john`, `smith`, or `okta` is rejected.
            const emailParts = options.email.split(/[.,\-_#@]+/);
            // [https://support.okta.com/help/s/question/0D51Y000069RzZISA0/password-policy-does-not-contain-part-of-username]
            // Parts that contain less than 4 characters are not used.
            const validEmailParts = emailParts.filter((part)=>part.length >= 4);
            return !validEmailParts.some((part)=>String(value).toUpperCase().includes(part.toUpperCase()));
        }
    });
});

exports.EXCLUDES_EMAIL_ERROR = EXCLUDES_EMAIL_ERROR;
//# sourceMappingURL=excludesEmail.js.map
